import { isNil } from 'lodash';
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { Grid, Dropdown, GridColumn } from 'semantic-ui-react';
import { Filter, Main } from 'Containers/';
import { convertEnumToDropdownArray } from 'Common/Constants/Enumeration/ConvertEnumToDropdownArray';

import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { getId } from 'Common/Security/state/selectors.js';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { ReactTableWrapper } from 'Common/Components/ReactTableWrapper/ReactTableWrapper';

import { errorToast, successToast } from 'Common/ToastHelper';

import {
  convertGridSortToSortColumn,
  convertGridFilterToFilter,
} from 'State/paging/helpers';

import { clearHub } from '../manageapplication/state/hub/actions';

import {
  getSelectedForVerification,
  declineToVerify,
  clearError,
  getAvailableToDecline,
  saveSelectionFilterOption,
} from './state/actions';
import { SelectedForVerificationFilterEnum } from './components/Constants';

class SelectedForVerificationContainer extends Component {
  reactTableRef = React.createRef();

  state = {
    selectedFilter: 0,
    filtered: [],
    sorted: [
      {
        id: 'HouseholdLastName',
        desc: false,
      },
      {
        id: 'HouseholdFirstName',
        desc: false,
      },
    ],
  };

  columns = [
    {
      Header: 'Family #',
      accessor: 'FamilyId',
      filterable: true,
      resizable: true,
      maxWidth: 100,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          Last Name
        </div>
      ),
      accessor: 'HouseholdLastName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          First Name
        </div>
      ),
      accessor: 'HouseholdFirstName',
      filterable: true,
      resizable: true,
    },
    {
      Header: (
        <div>
          HOH
          <br />
          SSN
        </div>
      ),
      accessor: 'HouseHouldSSN',
      filterable: true,
      resizable: true,
    },
    {
      Header: 'Verification Status',
      accessor: 'VerificationStatus',
      filterable: true,
      resizable: true,
    },
  ];

  getDropdownData() {
    return convertEnumToDropdownArray(SelectedForVerificationFilterEnum, true);
  }

  onFilterChange(value) {
    this.setState({ selectedFilter: value });
    const { saveSelectionFilterOption } = this.props;
    saveSelectionFilterOption(value === 1);
    if (this.reactTableRef) {
      this.reactTableRef.tableStateChanged();
    }
    this.menuOptions();
  }

  onDeclineToVerifyClick = (application) => {
    const { declineToVerify } = this.props;
    declineToVerify(application.FamilyId);
  };

  menuOptions = (verificationComplete) => {
    const { availableToDecline } = this.props;
    var options = [
      {
        icon: 'pencil',
        text: 'View/Edit',
        handler: (x) => this.onEditClick(x),
      },
    ];
    if (this.state.selectedFilter === 1 && availableToDecline > 0) {
      options = options.concat([
        {
          icon: 'cancel',
          text: 'Decline to verify',
          handler: this.onDeclineToVerifyClick,
        },
      ]);
    }
    return options;
  };

  componentDidMount() {
    const { isConfirmation, clearHub, getAvailableToDecline } = this.props;

    const filterValue = isConfirmation ? 1 : 0;

    this.onFilterChange(filterValue);
    clearHub();
    getAvailableToDecline();
    if (this.reactTableRef) {
      this.reactTableRef.tableStateChanged();
    }
  }

  componentDidUpdate(prevProps) {
    const { clearError } = this.props;

    errorToast(this.props, prevProps, 'error', clearError);

    successToast(
      this.props,
      prevProps,
      'declineForVerificationSuccessful',
      'Application successfully declined for verification.'
    );
  }

  fetchData = (state, instance) => {
    const { getSelectedForVerification } = this.props;
    let filters = convertGridFilterToFilter(state.filtered);
    let sorts = convertGridSortToSortColumn(state.sorted);

    let pageOptions = {
      ...this.props.applicationFilters.PagingDetails,
      PageNumber: state.page + 1,
      PageSize: state.pageSize,
      Filter: filters,
      SortColumn: sorts,
    };

    let page = {
      ...this.props.applicationFilters,
      PagingDetails: pageOptions,
      IsConfirmationReview: this.state.selectedFilter === 0 ? false : true,
    };

    getSelectedForVerification(page);
  };

  onEditClick = (application) => {
    this.props.history.push(
      `/manageapplication/${application.FamilyId}?secondReview=0&verification=1`
    );
  };

  fetchDataDebounced = debounce(this.fetchData, 250);

  render() {
    const { loading, selectedForVerification, availableToDecline } = this.props;

    const applicationData =
      (selectedForVerification && selectedForVerification.Data) || [];
    const data = applicationData.Result || [];
    const TotalPages = applicationData.TotalPages;

    const tableName = `${TableNamesEnum.MANAGE_APPLICATION_TABLE}_Verification`;
    return (
      <Fragment>
        <Filter title={'Selected For Verification'} newRow={true}>
          <Grid>
            <Grid.Row>
              <Grid.Column width="4">
                <label>Options</label>
                <Dropdown
                  placeholder="Filter Option"
                  fluid
                  selection
                  options={this.getDropdownData()}
                  onChange={(e, { value }) => {
                    this.onFilterChange(value);
                  }}
                  value={this.state.selectedFilter}
                />
              </Grid.Column>
              {this.state.selectedFilter === 1 && (
                <GridColumn width="3" floated="right">
                  <label>
                    Available for Decline:{' '}
                    {isNil(availableToDecline) ? 0 : availableToDecline}
                  </label>
                </GridColumn>
              )}
            </Grid.Row>
          </Grid>
        </Filter>

        <Main shouldNotUsePageWidth>
          <ReactTableWrapper
            key={tableName}
            onRef={(ref) => {
              this.reactTableRef = ref;
            }}
            manual
            data={data}
            saveState={{ tableName }}
            loading={loading}
            onFetchData={this.fetchDataDebounced}
            multiSort={false}
            minRows={data.length === 0 ? 20 : data.length}
            resetPageOnDataChange={false}
            menu="hasCogs"
            pages={TotalPages}
            getTrProps={(state, rowInfo, column) => {
              return {
                style: {
                  color:
                    rowInfo &&
                    rowInfo.original &&
                    rowInfo.original.StatusCurrent === '5'
                      ? 'red'
                      : '',
                },
              };
            }}
            columns={[
              ...this.columns,
              ...[
                {
                  width: 50,
                  Cell: (gridProps) => {
                    return GridContextMenu({
                      gridProps,
                      options: this.menuOptions(gridProps.original),
                    });
                  },
                },
              ],
            ]}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  getSelectedForVerification,
  declineToVerify,
  clearError,
  clearHub,
  getAvailableToDecline,
  saveSelectionFilterOption,
};

const mapStateToProps = (state) => {
  const { SelectForVerificationState } = state;

  return {
    userId: getId(state),
    selectedForVerification: SelectForVerificationState.selectedForVerification,
    applicationFilters: SelectForVerificationState.applicationFilters,
    availableToDecline: SelectForVerificationState.availableToDecline,
    loading: SelectForVerificationState.loading,
    isConfirmationReview: SelectForVerificationState.isConfirmationReview,
  };
};

export const SelectedForVerification = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SelectedForVerificationContainer)
);



// WEBPACK FOOTER //
// ./src/pages/selectedforverification/SelectedForVerification.js